export default __webpack_public_path__ + "static/media/dotDesign.a9a3e249.svg";